import { NavLink, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { 
  FileText, 
  Users, 
  BarChart3, 
  Settings, 
  LogOut,
  Plus,
  Calendar,
  Shield,
  Webhook
} from 'lucide-react'
import WelcomeModal from './WelcomeModal'

export default function Layout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/login')
  }

  const navItems = [
    { to: '/listings', icon: FileText, label: 'Listings' },
    { to: '/leads', icon: Users, label: 'Leads' },
    { to: '/analytics', icon: BarChart3, label: 'Analytics' },
    { to: '/webhooks', icon: Webhook, label: 'Integrations' },
    { to: '/settings', icon: Settings, label: 'Settings' },
    { to: '/admin/users', icon: Shield, label: 'Admin' },
  ]

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <WelcomeModal />
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div className="p-6">
          <h1 className="text-xl font-bold text-gray-900">InsideThisHome</h1>
          <p className="text-sm text-gray-500 mt-1">Dashboard</p>
        </div>

        <div className="px-4 pb-4 space-y-2">
          <NavLink
            to="/listings/new"
            className="flex items-center gap-2 w-full px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
          >
            <Plus size={18} />
            New Listing
          </NavLink>
          
          <a
            href="https://calendly.com/realestateos/inside-this-home-onboarding"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 w-full px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          >
            <Calendar size={18} />
            Schedule Onboarding
          </a>
        </div>

        <nav className="flex-1 px-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-gray-600 hover:bg-gray-100'
                }`
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-200">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-2 w-full text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <LogOut size={18} />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto p-8">
          {children}
        </div>
      </main>
    </div>
  )
}